import {SearchSubRuleListItem} from '../../../integrated-client/models/';

interface IRuleSearchesTableData {
  records: Array<SearchSubRuleListItem>
  totalItems?: number
}

export class RuleSearchesTableData implements IRuleSearchesTableData{
  records: Array<SearchSubRuleListItem>
  totalItems?: number

  constructor() {
    this.records = [];
  }

}
